import {Injectable} from '@angular/core';
import {Geolocation, PositionOptions} from '@capacitor/geolocation';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CapacitorGeolocationService {
  getCurrentPosition(options?: PositionOptions): Promise<GeolocationPosition> {
    return Geolocation.getCurrentPosition(options) as Promise<GeolocationPosition>;
  }

  watchPosition(options?: PositionOptions): Observable<GeolocationPosition> {
    return new Observable<GeolocationPosition>((subscriber) => {
      const watchIdPromise = Geolocation.watchPosition(options, (position, err) => {
        if (err) {
          subscriber.error(err);
          return;
        }
        if (position) {
          subscriber.next(position as GeolocationPosition);
        }
      });

      return () => {
        watchIdPromise.then((watchId) => {
          if (watchId) {
            Geolocation.clearWatch({id: watchId});
          }
        });
      };
    });
  }
}
